import { render, staticRenderFns } from "./TCreateForm.vue?vue&type=template&id=3c7e70ae&scoped=true"
import script from "./TCreateForm.vue?vue&type=script&lang=js"
export * from "./TCreateForm.vue?vue&type=script&lang=js"
import style0 from "./TCreateForm.vue?vue&type=style&index=0&id=3c7e70ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7e70ae",
  null
  
)

export default component.exports